import { render, staticRenderFns } from "./destroyLiquidity.vue?vue&type=template&id=d99d4c0a&scoped=true&"
import script from "./destroyLiquidity.vue?vue&type=script&lang=js&"
export * from "./destroyLiquidity.vue?vue&type=script&lang=js&"
import style0 from "./destroyLiquidity.vue?vue&type=style&index=0&id=d99d4c0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99d4c0a",
  null
  
)

export default component.exports